import React from 'react';
import { Countdown } from './Countdown';
import { OfferSelector } from './OfferSelector';
export const FinalCTA = () => {
  return <section className="py-8 sm:py-12 md:py-16 bg-cream border-t border-brand-orange/10" data-id="element-90">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-91">
        <div className="text-center mb-4 sm:mb-6" data-id="element-92">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-heading font-bold text-gray-900 mb-1 sm:mb-2" data-id="element-93">
            No dejes pasar esta oportunidad
          </h2>
          <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-5" data-id="element-94">
            Termina en
          </p>
          <div className="max-w-md mx-auto mb-4 sm:mb-6" data-id="element-95">
            <Countdown data-id="element-96" />
          </div>
        </div>

        <OfferSelector data-id="element-97" />
      </div>
    </section>;
};